import { Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const ModalConfirmCheckout = (props) => {
  const location = useLocation();

  const handlerCancel = () => {
    localStorage.removeItem("persist:root");
    if (location.pathname === "/ordersummary") {
      window.history.go(-2);
    }
  };

  return (
    <>
      <Modal show={props.show} onHide={props.onHide} backdrop="static" centered>
        <Modal.Header closeButton>
          <Modal.Title>Checkout Pemesanan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p style={{ fontSize: "18px" }}>
              Apakah Anda akan melanjutkan pemesanan <strong>Domain</strong>{" "}
              tanpa <strong>Hosting</strong> ?
            </p>
          </div>
          <div className="row mt-5">
            <div className="col-lg-6 col-12">
              <button
                className="btn btn-modal-outline-daftar-secondary w-100"
                onClick={handlerCancel}
              >
                Kembali
              </button>
            </div>
            <div className="col-lg-6 col-12">
              <button
                className="btn btn-modal-confirmation w-100"
                onClick={props.onHide}
              >
                Lanjutkan
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalConfirmCheckout;
